<template>
    <v-select
        :items="list"
        item-value="name"
        v-model="selected"
    >
        <template v-slot:item="{ item }">
            {{ item.title | translation }}
        </template>
        <template v-slot:selection="{ item }">
            {{ item.title | translation }}
        </template>
    </v-select>
</template>

<script>
export default {
    computed: {
        list() {
            return this.$currency.getList();
        },
        selected: {
            get() {
                return this.$currency.getSelected();
            },
            set(currency) {
                this.$currency.setSelected(currency);
            }
        }
    }
}
</script>